import {
    AppBar,
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select, SelectChangeEvent,
    Toolbar,
    Typography
} from "@mui/material";
import * as React from "react";
import {useAccount} from "@azure/msal-react";
import { useTranslation } from 'react-i18next';
import type {SupportedAppLocale} from "../util/LocalePreferences";

interface ApplicationBarProps {
    onLocaleSwitched :  ((e: SelectChangeEvent<SupportedAppLocale>) => void);
    locale: SupportedAppLocale;
}

const styles = {
    appBarContainer: {
        flexGrow: 1,
    },
    appBarTitle: {
        flexGrow: 1,
    },
    localeFormControl: {
        m: 1,
        minWidth: 120,
    },
    localeInputLabel: {
        color: "white",
    },
    localeSelectField: {
        color: "white",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "white",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "white",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "white",
        },
        "& .MuiSvgIcon-root": {
            color: "white",
        },
    }
};

export default function ApplicationBar({onLocaleSwitched, locale} : ApplicationBarProps) {
    const account = useAccount();
    const { t } = useTranslation();


    return (
        <Box sx={styles.appBarContainer}>
            <AppBar position="static">
            <Toolbar>
                <Typography variant="h6" component="div" sx={styles.appBarTitle}>
                    {t('applicationName')}
                </Typography>
                <FormControl sx={styles.localeFormControl} size="small" focused={false}>
                    <InputLabel id="demo-select-small-label" sx={styles.localeInputLabel}>{t('common.locale')}</InputLabel>
                    <Select<SupportedAppLocale>
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        value={locale}
                        label={t('common.locale')}
                        onChange={onLocaleSwitched}
                        sx={styles.localeSelectField}>
                        <MenuItem value={'en-US'}>English</MenuItem>
                        <MenuItem value={'ja-JP'}>日本語</MenuItem>
                        <MenuItem value={'ko-KR'}>한국어</MenuItem>
                        <MenuItem value={'zh-TW'}>國語</MenuItem>
                    </Select>
                </FormControl>
                <Button color="inherit">{account?.name}</Button>
            </Toolbar>
            </AppBar>
        </Box>
    );
}
